"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const StringRenderer_1 = tslib_1.__importDefault(require("./StringRenderer"));
const NumberRenderer_1 = tslib_1.__importDefault(require("./NumberRenderer"));
const DateRenderer_1 = tslib_1.__importDefault(require("./DateRenderer"));
const BooleanRenderer_1 = tslib_1.__importDefault(require("./BooleanRenderer"));
const NullRenderer_1 = tslib_1.__importDefault(require("./NullRenderer"));
const UndefinedRenderer_1 = tslib_1.__importDefault(require("./UndefinedRenderer"));
const BigIntRenderer_1 = tslib_1.__importDefault(require("./BigIntRenderer"));
class DefaultRenderer {
    canRender(o) {
        return !!this.findRenderer(o);
    }
    render(ctx, o) {
        let renderer = this.findRenderer(o);
        if (renderer) {
            renderer.render(ctx, o);
            ctx.currentCell?.classList.add("td-text");
        }
        else {
            throw new Error("Found no renderer for type " + typeof (o));
        }
    }
    findRenderer(o) {
        return DefaultRenderer.renderers.find(renderer => renderer.canRender(o));
    }
}
/* static*/
DefaultRenderer.renderers = [
    new StringRenderer_1.default(),
    new NumberRenderer_1.default(),
    new BooleanRenderer_1.default(),
    new DateRenderer_1.default(),
    new NullRenderer_1.default(),
    new UndefinedRenderer_1.default(),
    new BigIntRenderer_1.default()
];
exports.default = DefaultRenderer;
//# sourceMappingURL=DefaultRenderer.js.map